var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-snackbar',{staticClass:"white--text",attrs:{"color":_vm.snackbarColor,"tile":"","top":"","right":"","timeout":_vm.timeout},model:{value:(_vm.internalSnackbar),callback:function ($$v) {_vm.internalSnackbar=$$v},expression:"internalSnackbar"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }